// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"006d7144","147":"ed4aab3d","171":"c10b377b","296":"64bb38de","374":"91529c8c","432":"67b894f3","435":"c1949d06","453":"1cc3e3fa","466":"f4dea801","507":"e628c66a","580":"802544b5","743":"c5715ff4","780":"af7741dd"}[chunkId] + ".chunk.js";
};